module.exports = __webpack_public_path__ + "img/brand_logo_illustration.13492cc9.svg";